import React, { useState, useEffect, useRef } from 'react';

// Three-dot dropdown for secondary actions on a page header. Items prop
// is an array of { label, onClick, disabled?, danger?, icon? }. The menu
// closes on outside-click, Escape, or after any item fires.
export default function MoreMenu({ items, disabled }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const visible = (items || []).filter(Boolean);
  if (visible.length === 0) return null;

  return (
    <div ref={wrapRef} className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={open}
        title="More actions"
        className="bg-white rounded-xl border border-line text-fusion-mid-grey font-['Metropolis'] text-sm font-semibold w-10 h-10 inline-flex items-center justify-center hover:border-[#DADCCD] transition-colors disabled:opacity-50">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <circle cx="12" cy="5" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="12" cy="19" r="2" />
        </svg>
      </button>
      {open && (
        <div role="menu"
          className="absolute right-0 mt-1.5 w-56 bg-white border border-line rounded-xl shadow-xl z-20 overflow-hidden">
          {visible.map((item, i) => (
            <button
              key={i}
              type="button"
              role="menuitem"
              disabled={item.disabled}
              onClick={() => { if (item.disabled) return; setOpen(false); item.onClick?.(); }}
              className={`w-full text-left px-3.5 py-2.5 text-sm font-['Metropolis'] inline-flex items-center gap-2.5 transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
                item.danger
                  ? 'text-[#E0290A] hover:bg-[#E0290A]/10'
                  : 'text-fusion-mid-grey hover:bg-white'
              }`}>
              {item.icon && <span className="flex-shrink-0" aria-hidden="true">{item.icon}</span>}
              <span className="flex-1">{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
